import { Timestamp } from 'firebase/firestore';

export type ExamType = 'in_person' | 'online' | 'none';

export type GradeValue = 'S' | 'A+' | 'A' | 'A-' | 'B+' | 'B' | 'B-' | 'C+' | 'C' | 'C-' | 'F';

export type ReviewerYear = 1 | 2 | 3 | 4 | 5 | 6;

export type ReviewerYearKey = '1' | '2' | '3' | '4' | '5' | '6';

export type ReviewerFaculty = 'lc' | 'ia' | 'js' | 'pg';

export type ReviewTagCategory = 'language_communication' | 'seminar_practice' | 'evaluation_style' | 'class_atmosphere';

export type ReviewTag = {
  id: string;
  name: string;
  category: ReviewTagCategory;
  order: number;
};

export type CourseReview = {
  workload: number;
  format: number;
  examDifficulty: number;
  examType: ExamType;
  tags: string[];
  reviewerYear: ReviewerYear;
  reviewerFaculty: ReviewerFaculty;
  academicYear: string;
  semester: string;
  createdAt: Timestamp;
  updatedAt?: Timestamp;
};

export type CourseGrade = {
  grade: GradeValue;
  courseId: string;
  academicYear: string;
  semester: string;
  createdAt: Timestamp;
};

export type CourseReviewStats = {
  reviewCount: number;
  workloadAverage: number;
  formatAverage: number;
  examDifficultyAverage: number;
  examTypeCounts: {
    in_person: number;
    online: number;
    none: number;
  };
  tagCounts: Record<string, number>;
  reviewerYearCounts: Record<ReviewerYearKey, number>;
  reviewerFacultyCounts: Record<ReviewerFaculty, number>;
};

export type CourseGradeDistribution = Record<GradeValue, number>;

export const GRADE_KEYS: GradeValue[] = ['S', 'A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'F'];

export const REVIEWER_YEAR_KEYS: ReviewerYearKey[] = ['1', '2', '3', '4', '5', '6'];

export const REVIEWER_FACULTY_KEYS: ReviewerFaculty[] = ['lc', 'ia', 'js', 'pg'];

export const EMPTY_GRADE_DISTRIBUTION: CourseGradeDistribution = {
  S: 0,
  'A+': 0,
  A: 0,
  'A-': 0,
  'B+': 0,
  B: 0,
  'B-': 0,
  'C+': 0,
  C: 0,
  'C-': 0,
  F: 0,
};
